export const unavailableMediaLibrary = Object.freeze({
  isAvailable: () => false,
  list: async () => [],
  select: async () => [],
})
